import { Api } from '@/common/utils';

const normalizeLabel = (value) =>
  typeof value === 'string' ? value.replace(/Liablity/g, 'Liability') : value;

const normalizeDataEntryResponse = (response, overrides = {}) => {
  const props = response?.props || {};
  const overrideProps = overrides.props || {};

  return {
    ...response,
    ...overrides,
    props: {
      ...props,
      ...overrideProps,
      header: normalizeLabel(overrideProps.header || props.header),
      headerFr: overrideProps.headerFr || props.headerFr,
      listItemName: normalizeLabel(overrideProps.listItemName || props.listItemName),
      listItemNameFr: overrideProps.listItemNameFr || props.listItemNameFr,
      properties: (props.properties || []).map((property) => ({
        ...property,
        label: normalizeLabel(property.label),
        labelFr: normalizeLabel(property.labelFr),
      })),
    },
  };
};

export const getQuestionList = async (section, decedentId) => {
  const {
    data: { list, answers },
  } = await Api.request({
    url: `/question/list?section=${section}&decedentId=${decedentId}`,
  });

  return {
    list,
    answers,
  };
};

export const getFilledDataEntries = async (decedentId) => {
  const {
    data: { list },
  } = await Api.request({
    url: `/question/list/filled-data-entry?decedentId=${decedentId}`,
  });

  return list;
};

export const getFinancialInstitutions = async (decedentId) => {
  const {
    data: { list },
  } = await Api.request({
    url: `/question/list/financial-institutions?decedentId=${decedentId}`,
  });

  return list;
};

export const getOtherFinancialLiabilities = async (decedentId) => {
  const { data } = await Api.request({
    url: `/question/list/other-financial-liabilities?decedentId=${decedentId}`,
  });

  return normalizeDataEntryResponse(data, {
    props: {
      header: 'Other Financial Liabilities',
      headerFr: 'Autres passifs financiers',
      listItemName: 'Financial Liability',
      listItemNameFr: 'Responsabilite financiere',
    },
  });
};

export const getOtherCreditCards = async (decedentId) => {
  const { data } = await Api.request({
    url: `/question/list/other-credit-cards?decedentId=${decedentId}`,
  });

  return normalizeDataEntryResponse(data, {
    props: {
      header: 'Other Credit Cards',
      headerFr: 'Autres cartes de credit',
      listItemName: 'Credit Card',
      listItemNameFr: 'Carte de credit',
    },
  });
};

export const submitAnswers = async (payload) => {
  await Api.request({
    url: '/question/submit',
    method: 'post',
    payload,
  });

  return payload;
};
